import { Button, Grid, TextField } from '@mui/material'
import { memo, useContext, useState } from 'react'
import InputMask from 'react-input-mask'
import { GlobalContext } from '../../../App'
import { metodoPrograma } from '../../../components/api'
import { z } from 'zod'
import { Controller, useForm } from 'react-hook-form'
import { zodResolver } from '@hookform/resolvers/zod'
import dayjs from 'dayjs'
import AutoComplete from '../../../components/AutoComplete/AutoComplete'
import FormattedTextEditor from '../../../components/FormattedTextEditor/FormattedTextEditor'

const createMedico = z.object({
  cdMedico: z.string().optional(),
  nmMedico: z.string(),
  cdCpf: z.string(),
  dsEmail: z.string(),
  nrCelular: z.string(),
  dtNascimento: z.string(),
  dsObservacaoReceituario: z.string().optional(),
})

const retornaLocalAtendimento = (u = []) => ({
  cdMedico: u?.[0] || '',
  nmMedico: u?.[1] || '',
  cdCpf: u?.[3] || '',
  dsEmail: u?.[5] || '',
  nrCelular: u?.[4] || '',
  dtNascimento: u?.[2] ? dayjs(u?.[2]).format('YYYY-MM-DD') : '',
  dsObservacaoReceituario: u?.[8] || '',
})

const Edicao = ({ dados, voltar }) => {
  const { localAtendimento } = useContext(GlobalContext)
  const [acUsuario, setAcUsuario] = useState(dados?.[9] || [])

  const { register, handleSubmit, control } = useForm({
    defaultValues: retornaLocalAtendimento(dados),
    resolver: zodResolver(createMedico),
  })

  const removerCaracteresEspeciais = (valor = '') => {
    return valor.replace(/\D/g, '')
  }

  const salva = async (values) => {
    values.cdCpf = removerCaracteresEspeciais(values.cdCpf)
    values.nrCelular = removerCaracteresEspeciais(values.nrCelular)
    const obj = {
      ...values,
      usuarios: acUsuario,
      dtNascimento: values.dtNascimento
        ? dayjs(values.dtNascimento).format('YYYY-MM-DD HH:mm:ss')
        : undefined,
      idLocalAtendimento: localAtendimento[0],
    }
    const res = await metodoPrograma('salva', obj)
    if (res.status) voltar()
  }

  return (
    <form onSubmit={handleSubmit(salva)} style={{ width: '100%', padding: 0 }}>
      <Grid container spacing={2}>
        <Grid item xs={12} sm={10}>
          <TextField
            {...register('nmMedico')}
            label="Nome"
            fullWidth
            margin="dense"
            variant="outlined"
          />
        </Grid>
        <Grid item xs={12} sm={2}>
          <TextField
            type="date"
            {...register('dtNascimento')}
            label="Data Nascimento"
            fullWidth
            margin="dense"
            variant="outlined"
          />
        </Grid>
        <Grid item xs={12} sm={3}>
          <TextField
            {...register('cdMedico')}
            label="Número Conselho"
            fullWidth
            margin="dense"
            variant="outlined"
          />
        </Grid>
        <Grid item xs={12} sm={3}>
          <Controller
            name="cdCpf"
            control={control}
            render={({ field }) => (
              <InputMask
                mask="999.999.999-99"
                value={field.value || ''}
                onChange={field.onChange}
              >
                {(inputProps) => (
                  <TextField
                    {...inputProps}
                    label="CPF"
                    variant="outlined"
                    margin="dense"
                    fullWidth
                  />
                )}
              </InputMask>
            )}
          />
        </Grid>
        <Grid item xs={12} sm={3}>
          <Controller
            name="nrCelular"
            control={control}
            render={({ field }) => (
              <InputMask
                mask="(99) 99999-9999"
                value={field.value || ''}
                onChange={field.onChange}
              >
                {(inputProps) => (
                  <TextField
                    {...inputProps}
                    label="Telefone"
                    variant="outlined"
                    margin="dense"
                    fullWidth
                  />
                )}
              </InputMask>
            )}
          />
        </Grid>

        <Grid item xs={12} sm={3}>
          <TextField
            {...register('dsEmail')}
            label="E-mail"
            fullWidth
            margin="dense"
            variant="outlined"
          />
        </Grid>
        <Grid item xs={12}>
          <AutoComplete
            multiple
            InputLabelProps={{ shrink: true }}
            filterSelectedOptions
            label="Usuário"
            metodo="buscaUsuario"
            value={acUsuario}
            size="small"
            onChange={(_, val) => setAcUsuario(val)}
          />
        </Grid>
        <Grid item xs={12}>
          <Controller
            name="dsObservacaoReceituario"
            control={control}
            render={({ field }) => (
              <FormattedTextEditor
                {...field}
                label="Observação do receituário"
                minHeight={220}
              />
            )}
          />
        </Grid>
        <Grid
          item
          xs={12}
          style={{ display: 'flex', flexDirection: 'row-reverse' }}
        >
          <Button
            type="submit"
            variant="contained"
            color="primary"
            style={{ margin: '5px' }}
          >
            Salvar
          </Button>
          <Button
            onClick={voltar}
            variant="contained"
            color="secondary"
            style={{ margin: '5px' }}
          >
            Cancelar
          </Button>
        </Grid>
      </Grid>
    </form>
  )
}

export default memo(Edicao)
